import React from "react";

export function SearchIcon(props: { color?: string }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                stroke={props?.color || "#B1B5BD"}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.15"
                d="M7.772 14.294a6.522 6.522 0 1 0 0-13.044 6.522 6.522 0 0 0 0 13.044M14.98 14.98l-1.373-1.372"
            ></path>
        </svg>
    );
}
